// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class Greeks {
    constructor() {
        this.iv = NaN;
        this.delta = NaN;
        this.gamma = NaN;
        this.vega = NaN;
        this.theta = NaN;
        this.rho = NaN;
    }
    get ivPercent() {
        return this.iv * 100;
    }
    isEmpty() {
        return (isNaN(this.iv) &&
            isNaN(this.delta) &&
            isNaN(this.gamma) &&
            isNaN(this.vega) &&
            isNaN(this.theta) &&
            isNaN(this.rho));
    }
}
